<template>
  <section class="modal-card"
  :class="{'has-error':isDanger}">
    <header class="modal-card-head">
      <p class="modal-card-title">{{headerTitle}}</p>
      <button
        type="button"
        class="modal-close is-large"
        @click="$emit('close')"/>
    </header>
    <section class="modal-card-body">
      <div class="media-left">
        <span v-if="isDanger" class="icon has-text-danger is-large">
          <i class="fa fa-exclamation-circle fa-3x"></i>
        </span>
      </div>
      <div class="media-content">
        <p v-html="content">
          {{content}}
        </p>
      </div>
    </section>
  </section>
</template>

<script>

export default {
  name: 'Notification',
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    isDanger: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="stylus">
.has-text-danger
  float left
  margin-right: 15px;
.modal-card-body
  border-bottom-left-radius 6px
  border-bottom-right-radius 6px
.media-content >>> .notification-group-ref
  padding-right 10px
  color #525F66
  position relative
  display inline-flex
  width 90px
.media-content >>> .notification-group-ref::before
  content: url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='14' cy='14' r='13.5' fill='white' stroke='%23525F66'/%3E%3Cpath d='M20.3536 14.3536C20.5488 14.1583 20.5488 13.8417 20.3536 13.6464L17.1716 10.4645C16.9763 10.2692 16.6597 10.2692 16.4645 10.4645C16.2692 10.6597 16.2692 10.9763 16.4645 11.1716L19.2929 14L16.4645 16.8284C16.2692 17.0237 16.2692 17.3403 16.4645 17.5355C16.6597 17.7308 16.9763 17.7308 17.1716 17.5355L20.3536 14.3536ZM7 14.5H20V13.5H7V14.5Z' fill='%23525F66'/%3E%3C/svg%3E")
  position: absolute
  top 0px
  left 60px
  width 28px
  height 28px
.media-content >>> .notification-group-ref:hover::before
  content: url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='14' cy='14' r='13.5' fill='%23525F66' stroke='%23525F66'/%3E%3Cpath d='M20.3536 14.3536C20.5488 14.1583 20.5488 13.8417 20.3536 13.6464L17.1716 10.4645C16.9763 10.2692 16.6597 10.2692 16.4645 10.4645C16.2692 10.6597 16.2692 10.9763 16.4645 11.1716L19.2929 14L16.4645 16.8284C16.2692 17.0237 16.2692 17.3403 16.4645 17.5355C16.6597 17.7308 16.9763 17.7308 17.1716 17.5355L20.3536 14.3536ZM7 14.5H20V13.5H7V14.5Z' fill='white'/%3E%3C/svg%3E")

section.modal-card
  width 600px
  min-height 180px
  @media screen and (max-width: 596px)
    width: 100%

section.modal-card.has-error
  min-height 221px
.modal-card-head
  height 60px
p.modal-card-title
  font-size 30px
  font-weight 700
.media-content >>> .close-link
  color #525f66
  font-weight 700
</style>
